import React from 'react';
import { formatCount, formatShortDate } from '../lib/format';

/**
 * "Hvorfor de gikk" — the `cancellations` block of GET /api/admin/metrics
 * (backend lib/adminMetrics.js): all-time stops per exit-survey reason, with
 * 'none' for skipped answers and cancellations made in the Vipps app.
 *
 * The recent list carries parents' own words — no user ids, but possibly
 * details about a child — so it sits inside a CLOSED <details>: the wall
 * screen shows only the counts until someone deliberately opens it.
 * Renders nothing against a backend that predates the field.
 */

export const REASON_LABELS = {
  granted: 'Fikk innvilget',
  too_expensive: 'For dyrt',
  unmet_need: 'Fikk ikke det de trengte',
  other: 'Annet',
  none: 'Uten svar'
};
const REASON_ORDER = ['granted', 'too_expensive', 'unmet_need', 'other', 'none'];

export default function CancellationsCard({ cancellations }) {
  if (!cancellations) return null;
  const byReason = cancellations.byReason || {};
  const recent = Array.isArray(cancellations.recent) ? cancellations.recent : [];

  return (
    <section className="admin-card admin-card--cancellations" aria-label="Avslutninger">
      <div className="admin-card__label">Hvorfor de gikk</div>
      <ul className="admin-reasons">
        {REASON_ORDER.map((key) => (
          <li key={key} className="admin-reasons__row">
            <span>{REASON_LABELS[key]}</span>
            <span className="admin-reasons__count">{formatCount(byReason[key] ?? 0)}</span>
          </li>
        ))}
      </ul>
      <details className="admin-recent">
        <summary>Siste avslutninger ({formatCount(recent.length)})</summary>
        {recent.length === 0 ? (
          <p className="admin-recent__empty">Ingen ennå.</p>
        ) : (
          <ol className="admin-recent__list">
            {recent.map((item, i) => (
              <li key={`${item.date}-${i}`} className="admin-recent__item">
                <div className="admin-recent__meta">
                  {formatShortDate(item.date)} · {REASON_LABELS[item.reason] || REASON_LABELS.none}
                </div>
                {item.text && <div className="admin-recent__text">«{item.text}»</div>}
              </li>
            ))}
          </ol>
        )}
      </details>
    </section>
  );
}
